import type { FC, SVGProps } from "react";

const WarningCircleIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		width="36"
		height="36"
		viewBox="0 0 36 36"
		fill="none"
		aria-hidden="true"
		{...props}
	>
		<circle cx="18" cy="18" r="18" fill="#FFE1E1" />
		<path
			d="M18 12v7"
			stroke="#F23C3C"
			strokeWidth="2.5"
			strokeLinecap="round"
		/>
		<circle cx="18" cy="24" r="1.5" fill="#F23C3C" />
	</svg>
);

export { WarningCircleIcon };
